<div class="my-bets-editing-overlay" [ngClass]="{ 'bet-placing-mode': isBetPlacingInProgress }">
    <div class="my-bets-editing-message">{{ sitecoreMyBets.myBets.EditBetMyBetsCard }}</div>
    @if (!isBetPlacingInProgress) {
        <button ds-button kind="tertiary" variant="outline" size="large" (click)="onCancelClick()">
            {{ sitecore.betslip.editBet.cancel }}
        </button>
    }
    <ms-loading-indicator></ms-loading-indicator>
</div>
